/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */

import { NgModule } from '@angular/core';

import { NbSharedModule } from '../shared/shared.module';
import { NbProgressBarComponent } from './progress-bar.component';

@NgModule({
  imports: [
    NbSharedModule,
  ],
  declarations: [NbProgressBarComponent],
  exports: [NbProgressBarComponent],
})
export class NbProgressBarModule { }



// WEBPACK FOOTER //
// /srv/staging/FitRadioAdmin2/src/app/@nebular/theme/components/progress-bar/progress-bar.module.ts